import type { IconDefinition } from "@/icons/solid-icons";
import type { ReactNode } from "react";

// Tooltip Content
export interface ITooltipContent {
  /**
   * The unique identifier for the tooltip.
   * Optional.
   */
  id?: string;

  /**
   * The main information to be displayed in the tooltip.
   */
  info: string;
  /**
   * The title of the tooltip.
   * Optional.
   */
  title?: string;
  /**
   * The text to be displayed on the button.
   * Optional.
   */
  buttonText?: string;
  /**
   * The function to be called when the button is clicked.
   * Optional.
   */
  buttonOnClick?: () => void;
  /**
   * Flag indicating whether to show the button.
   * Optional.
   */
  showButton?: boolean;
  /**
   * The width of the tooltip.
   * Optional.
   */
  width?: string;
}

// Tooltip Wrapper

// Define possible positions for the tooltip
export enum TooltipPosition {
  Top = "top",
  TopStart = "top-start",
  TopEnd = "top-end",
  Bottom = "bottom",
  BottomStart = "bottom-start",
  BottomEnd = "bottom-end",
  Left = "left",
  LeftStart = "left-start",
  LeftEnd = "left-end",
  Right = "right",
  RightStart = "right-start",
  RightEnd = "right-end",
}

// Define possible triggers for the tooltip
export enum TooltipTrigger {
  Click = "click",
  Hover = "mouseenter",
}

export interface ITooltipWrapper {
  /**
   * The unique identifier for the tooltip.
   * Optional.
   */
  id?: string;

  /**
   * The content to be displayed inside the tooltip.
   * This can be any renderable React content.
   */
  content: ReactNode;

  /**
   * The icon to be displayed alongside the tooltip content.
   * This should be a valid icon from the icon library being used.
   */

  icon: IconDefinition;

  /**
   * The action that triggers the tooltip.
   * Optional
   * Possible values: Click, Hover
   * @default TooltipTrigger.Hover
   */
  trigger?: TooltipTrigger;

  /**
   * The position of the tooltip relative to the trigger element.
   * Optional.
   * Possible values: Top, TopStart, TopEnd, Bottom, BottomStart, BottomEnd, Left, LeftStart, LeftEnd, Right, RightStart, RightEnd
   * @default TooltipPosition.Top
   */
  position?: TooltipPosition;

  /**
   * Whether the tooltip is interactive.
   * If true, the tooltip can be interacted with (e.g., clickable links).
   * Optional, defaults to false.
   */
  interactive?: boolean;
}
